/**
 * 错误处理相关常量和枚举
 */

/**
 * 错误展示类型枚举
 * 定义了不同类型错误的展示方式
 */
export enum ErrorShowType {
  /** 不显示错误 */
  SILENT = 0,
  /** 警告消息 */
  WARN_MESSAGE = 1,
  /** 错误消息 */
  ERROR_MESSAGE = 2,
  /** 通知弹框 */
  NOTIFICATION = 3,
  /** 重定向 */
  REDIRECT = 9,
}

/**
 * 错误处理配置
 * 与后端约定的响应数据格式
 */
export interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}
